import { px } from '@adsk/alloy-react-helpers';

import {
  AlloyLegacyThemeDesignTokens,
  StatusColorIndicatorDesignTokens,
} from '../types';
import { WeaveTheme } from '../types/weaveTypes';

type WeaveTokens = NonNullable<WeaveTheme['tokens']>;

export const getStatusColorIndicatorTokensAlloy = (
  theme: AlloyLegacyThemeDesignTokens,
): StatusColorIndicatorDesignTokens => ({
  width: '6px',
  height: '40px',
  'border-radius': px(theme.borderRadius.small),
  colors: {
    blue: theme.colors.adskBlue500,
    yellow: theme.colors.yellowOrange500,
    green: theme.colors.green500,
    purple: theme.colors.purple500,
    red: theme.colors.red500,
    'gray-light': theme.colors.charcoal200,
    gray: theme.colors.charcoal700,
    'gray-dark': theme.colors.charcoal900,
    white: theme.colors.white,
    turquoise: theme.colors.turquoise500,
    'dark-blue': theme.colors.darkBlue300,
  },
});

export const getStatusColorIndicatorTokensWeave = (
  tokens: WeaveTokens,
): StatusColorIndicatorDesignTokens => {
  const color = tokens?.generic?.color;

  return {
    width: '6px',
    height: '40px',
    'border-radius': tokens?.generic?.['border-radius']?.['2'],
    colors: {
      blue: color?.blue?.[500]?.[100],
      yellow: color?.orange?.[500]?.[100],
      green: color?.green?.[500]?.[100],
      purple: color?.purple?.[600]?.[100],
      red: color?.red?.[500]?.[100],
      'gray-light': color?.charcoal?.[200]?.[100],
      gray: color?.charcoal?.[700]?.[100],
      'gray-dark': color?.charcoal?.[900]?.[100],
      white: color?.white?.[100],
      turquoise: color?.turquoise?.[500]?.[100],
      'dark-blue': color?.navy?.[300]?.[100],
    },
  };
};
